// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"styles_loadingWrapper__vFfi6","rotation":"styles_rotation__MJYc8","small":"styles_small__9xmrX","regular":"styles_regular__4oFOn","large":"styles_large__AEZ8y"};